import { ChangeDetectionStrategy, Component, forwardRef, input, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

export interface FilterPill<T> {
  label: string;
  value: T;
}

@Component({
  selector: 'app-filter-pills',
  templateUrl: './filter-pills.component.html',
  styleUrl: './filter-pills.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterPillsComponent),
      multi: true,
    }
  ],
  imports: [
    TranslateModule,
  ]
})
export class FilterPillsComponent implements ControlValueAccessor {
  pills = input<FilterPill<unknown>[]>([]);

  selectedPill = signal<unknown>(null);
  disabled = signal<boolean>(false);

  private onChange = (_value: unknown) => {};
  private onTouched = () => {};

  writeValue(value: unknown): void {
    this.selectedPill.set(value);
  }

  registerOnChange(fn: (_value: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  selectPill(value: unknown): void {
    if (this.disabled()) {
      return;
    }

    this.selectedPill.set(value);
    this.onChange(value);
    this.onTouched();
  }
}
